// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o545","newExpiryDate":"styles_newExpiryDate__3jsPv","footer":"styles_footer__IQUYS"};